module.exports = __webpack_public_path__ + "img/csr_swiper_03.bcd16d96.jpg";